module.exports = __webpack_public_path__ + "media/images/Successful-purchase-pana-b4c5ceb6ffbacf649064b29798854446.jpg";